import * as React from 'react';
import { Notification } from '../Notification/Notification';

export interface INotificationFullWidthProps {
    notificationType: string;
    notificationText: string;
    onCloseCallback?: () => void;
}

export interface INotificationFullWidthState {
    show: boolean;
}

/**
 * A wrapper around [[Notification]] which is rendered as full width.
 */
export class NotificationFullWidth extends React.Component<INotificationFullWidthProps, INotificationFullWidthState> {
    static defaultProps = {
		onCloseCallback: () => {}
	}
    constructor(props: INotificationFullWidthProps) {
    super(props);
    this.state = {
        show: true
    }
  }

  close = () =>  {
    this.setState({
        show: false
    },
    () => this.props.onCloseCallback()
    );
  }

 
  public render() {
    return (
        this.state.show && (
            <div className={`notification--${this.props.notificationType}`}>
                <div className="container">
                    <div className="col">
                        <Notification
                            notificationText={this.props.notificationText}
                            notificationType={this.props.notificationType}
                            onCloseCallback={this.close}
                        />
                    </div>
                </div>
            </div>
        )
    );
  }
}
